// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_ON,
} from 'components/header-layout/constants/header-layout.constants';
import {
  ANDROID_NOT_DESKTOP_FALLBACK_URL,
  DESKTOP_FALLBACK_URL,
  IOS_NOT_DESKTOP_FALLBACK_URL,
} from 'utils/constants/app-callback-url.utils.constants';
// Utilities
import {
  isAndroidDevice,
  isAndroidWebview,
  isIOSDevice,
  isIOSWebview,
  isLikelyWebViewDevice,
} from '@openbank/cf-ui-framework';
import { getCallbackUrl } from './browser-url.utils';
import { AppContextType } from 'contexts/types/app.contexts.type';

const getiOSVersion = (): number | null => {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    const match = navigator.appVersion.match(/OS (\d+)_/);
    if (match) {
      return parseInt(match[1], 10);
    }
  }
  return null;
};

const getSafariVersion = (): string | null => {
  const ua = navigator.userAgent;
  const match = ua.match(/Version\/([\d.]+)\sSafari/);
  return match ? match[1] : null;
};

// eslint-disable-next-line complexity
const getFallbackCallbackUrl = (): string => {
  switch (true) {
    case isAndroidDevice():
    case isAndroidWebview():
    case isAndroidDevice() && isLikelyWebViewDevice():
      return ANDROID_NOT_DESKTOP_FALLBACK_URL;
    case isIOSDevice():
    case isIOSWebview():
    case isIOSDevice() && isLikelyWebViewDevice():
      return IOS_NOT_DESKTOP_FALLBACK_URL;
    default:
      return DESKTOP_FALLBACK_URL;
  }
};
//
// const navigateToCallbackUrl = (stateUrl: string): void => {
//   let callbackUrl;
//
//   try {
//     callbackUrl = getCallbackUrl();
//   } catch (error) {
//     console.error('Error getting callback URL from query params:', error);
//     callbackUrl = '';
//   }
//
//   const url: any = stateUrl || callbackUrl || getFallbackCallbackUrl();
//
//   localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
//
//   try {
//     window.location = url;
//   } catch (error) {
//     console.error('Error navigating to callback URL:', error);
//     alert('An error occurred while trying to use window.location. Using window location replace.');
//     window.location.replace(url);
//   }
// };

const getCallbackLoanUrl = ({
  callbackUrl,
  loanId,
}: Pick<AppContextType, 'callbackUrl' | 'loanId'>): any => {
  const iosCallback = 'com.amazon.mobile.shopping://amazon.es/CloseInAppBrowser';
  const androidCallback =
    'com.amazon.mobile.shopping.thirdpartynavigation://amazon.es/CloseInAppBrowser';
  const encodedTargetUrl = encodeURIComponent(
    'https://www.amazon.es/gil/es/santander/wait?loanApplicationId=' + loanId
  );

  const url = callbackUrl || getCallbackUrl();

  switch (url) {
    case iosCallback:
      return iosCallback + '?targetURL=' + encodedTargetUrl;
    case androidCallback:
      return androidCallback + '?targetURL=' + encodedTargetUrl;
    default:
      return url;
  }
};

const navigateToCallbackUrl = (props: Pick<AppContextType, 'callbackUrl' | 'loanId'>): void => {
  localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
  window.location = getCallbackLoanUrl(props);
};

export {
  getFallbackCallbackUrl,
  getCallbackLoanUrl,
  navigateToCallbackUrl,
  getiOSVersion,
  getSafariVersion,
};
